(function () {
    // Export these globally as util functions for testing
    window.setMobileSite = function () {
        createCookie('mobileOrFullSite', 'mobile', null);
        location.reload();
    };

    window.setFullSite = function () {
        createCookie('mobileOrFullSite', 'full', null);
        location.reload();
    };

    function getMobileOrFullSite(mobileOrFull) {
        const viewports = $('meta[name=viewport]');
        if (!isiPad && isMobileDevice && mobileOptimized) {
            viewports.remove();
            if (mobileOrFull == 'full') {
                $('head').append('<meta name="viewport" content="width=980, minimum-scale=.25" />');
            } else {
                $('head').append('<meta name="viewport" content="width=device-width,initial-scale=1" />');
            }
        } else if (isiPad) {
            viewports.remove();
            $('head').append('<meta name="viewport" content="width=1024">');
        }
    }

    $(window).bind('orientationchange', function () { getMobileOrFullSite((readCookie('mobileOrFullSite') != null) ? readCookie('mobileOrFullSite') : 'mobile'); });

    // Used in lots of JS
    window.isMobileView = function () {
        return !!((isMobileDevice || $(window).width() <= 736) && mobileOptimized && (readCookie('mobileOrFullSite') == null || readCookie('mobileOrFullSite') == 'mobile'));
    };
})();
